import { Header1 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import { PublicApplicationData } from '@flatsy/types/Applications'
import { FrontApplicationBookingState } from '@flatsy/types/Applications/BookingStatus'
import i18n from '@flatsy/utils/translations'
import { ClassNameMap } from '@material-ui/styles'

export const renderTitleShowWeeks = (application: PublicApplicationData): React.ReactNode => {
  return application.computedBookingState === FrontApplicationBookingState.RESCHEDULED ? (
    <Header1 lowerCase fontColor={theme.palette.primary.dark}>
      {i18n.t('choose_a_new_visiting_slot')}
    </Header1>
  ) : (
    <Header1 fontColor={theme.palette.primary.dark} align="center" lowerCase>
      {i18n.t('choose_time_slot_for_tour')}
    </Header1>
  )
}

export const renderTitleHightlightSlot = (
  application: PublicApplicationData,
  classes: ClassNameMap<'bookingHeaderTitle'>
): React.ReactNode => {
  return application.computedBookingState === FrontApplicationBookingState.RESCHEDULED ? (
    <Header1
      lowerCase
      align="center"
      fontColor={theme.palette.primary.dark}
      className={classes.bookingHeaderTitle}
    >
      {i18n.t('choose_a_new_visiting_slot')}
    </Header1>
  ) : (
    <Header1
      fontColor={theme.palette.primary.dark}
      className={classes.bookingHeaderTitle}
      align="center"
      lowerCase
    >
      {i18n.t('choose_time_slot_for_tour')}
    </Header1>
  )
}
